import { Link } from "react-router-dom";

const ReliableTransportationForBusinessEvents = () => {
    return (
        <section className="bg-primary">
            <div className="max-w-7xl mx-auto px-4">
                <div className="py-20 md:py-28">

                    <div className="text-center">

                        <p className="text-white/70 text-sm uppercase tracking-widest">
                            Corporate Travel
                        </p>

                        <h1 className="mt-4 text-white text-4xl md:text-6xl font-bold max-w-5xl mx-auto leading-tight">
                            The Importance Of Reliable Transportation For Business Events
                        </h1>

                        <div className="mt-8 flex flex-wrap justify-center gap-4 text-white/70">
                            <span>June 22, 2026</span>
                            <span>•</span>
                            <span>Velox Charter</span>
                        </div>

                    </div>

                </div>
            </div>

            <section className="bg-[#F9FAFB] py-16 lg:py-24">
                <div className="max-w-7xl mx-auto px-4">

                    <div className="grid lg:grid-cols-12 gap-10">

                        <div className="lg:col-span-8">

                            <div className="bg-white rounded-[30px] overflow-hidden shadow-sm">

                                <img
                                    src="/images/business-events.png"
                                    alt="Business Event Transportation"
                                    className="w-full h-[300px] md:h-[500px] object-cover"
                                />

                                <div className="p-8 md:p-12">
                                    <p className="text-[#666666] leading-8 text-lg">
                                        Business events require careful planning,
                                        coordination, and attention to detail.
                                        Whether you're organizing a conference,
                                        trade show, executive meeting, corporate
                                        retreat, networking event, or company
                                        celebration, transportation plays a
                                        critical role in ensuring everything
                                        runs smoothly.
                                    </p>

                                    <p className="mt-6 text-[#666666] leading-8 text-lg">
                                        Reliable transportation not only helps
                                        attendees arrive on time but also
                                        contributes to professionalism,
                                        productivity, and the overall success of
                                        the event.
                                    </p>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            1. Creates A Professional First Impression
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            First impressions matter in business.
                                            Arranging professional transportation
                                            for executives, clients, speakers,
                                            and guests demonstrates organization,
                                            professionalism, and attention to
                                            detail.
                                        </p>

                                        <ul className="mt-5 space-y-3 text-[#666666]">
                                            <li>✓ Professional Appearance</li>
                                            <li>✓ Improved Brand Image</li>
                                            <li>✓ Enhanced Guest Experience</li>
                                            <li>✓ Positive Event Perception</li>
                                        </ul>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            2. Ensures Timely Arrivals
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Delays can negatively impact meeting
                                            schedules, keynote presentations, and
                                            event activities. Reliable charter
                                            transportation helps keep attendees
                                            on schedule by coordinating pickups,
                                            routes, and arrival times.
                                        </p>

                                        <div className="grid sm:grid-cols-2 gap-4 mt-6">
                                            {[
                                                "Executive Meetings",
                                                "Corporate Conferences",
                                                "Networking Events",
                                                "Trade Shows",
                                            ].map((item, index) => (
                                                <div
                                                    key={index}
                                                    className="bg-[#F8FAFC] border rounded-[16px] p-5"
                                                >
                                                    {item}
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            3. Improves Attendee Experience
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Transportation directly impacts how
                                            attendees perceive an event.
                                            Comfortable and organized travel
                                            helps guests feel valued while
                                            reducing stress related to traffic,
                                            parking, and navigation.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            4. Simplifies Event Logistics
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Coordinating transportation through a
                                            professional provider simplifies
                                            logistics and reduces the burden on
                                            event organizers. Transportation
                                            teams can manage routes, schedules,
                                            pickup locations, and passenger
                                            coordination.
                                        </p>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            This allows event planners to focus
                                            on the event itself rather than
                                            transportation challenges.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            5. Supports Productivity During Travel
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Business professionals often use
                                            travel time to prepare for meetings,
                                            respond to emails, review
                                            presentations, or collaborate with
                                            colleagues.
                                        </p>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Professional transportation allows
                                            passengers to remain productive
                                            instead of focusing on driving,
                                            parking, or navigation.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            6. Enhances Safety
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Safety should always be a priority
                                            for corporate events. Professional
                                            transportation providers maintain
                                            modern fleets, employ experienced
                                            drivers, and follow strict safety
                                            standards.
                                        </p>

                                        <ul className="mt-5 space-y-3 text-[#666666]">
                                            <li>✓ Professional Drivers</li>
                                            <li>✓ Routine Vehicle Maintenance</li>
                                            <li>✓ Advanced Safety Features</li>
                                            <li>✓ Reliable Travel Planning</li>
                                        </ul>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            7. Accommodates Groups Of All Sizes
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Business events often involve groups
                                            ranging from a handful of executives
                                            to hundreds of attendees. Reliable
                                            transportation providers offer
                                            flexible vehicle options to meet
                                            varying group sizes.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            8. Strengthens Corporate Reputation
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            When attendees experience organized,
                                            comfortable, and dependable
                                            transportation, it reflects
                                            positively on your company. Reliable
                                            transportation contributes to a more
                                            professional and memorable event.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            Final Thoughts
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Transportation is often overlooked
                                            during event planning, yet it plays
                                            a major role in the success of any
                                            business event. Reliable
                                            transportation improves punctuality,
                                            enhances guest experiences, supports
                                            productivity, and helps create a
                                            professional image.
                                        </p>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Whether you're organizing a small
                                            executive meeting or a large-scale
                                            corporate conference, investing in
                                            professional transportation services
                                            can help ensure your event runs
                                            smoothly from start to finish.
                                        </p>
                                    </div>

                                </div>

                            </div>

                        </div>

                        <div className="lg:col-span-4">

                            <div className="sticky top-6">

                                <div className="bg-primary rounded-[24px] p-8 text-center">

                                    <h3 className="text-white text-2xl font-semibold">
                                        Planning A Business Event?
                                    </h3>

                                    <p className="mt-4 text-white/80 leading-7">
                                        Let Velox Charter provide reliable,
                                        professional transportation solutions
                                        for your next conference, meeting, or
                                        corporate event.
                                    </p>

                                    <Link
                                        to="/contact-us"
                                        className="mt-4 inline-block bg-white text-primary px-8 py-4 rounded-full font-semibold hover:scale-105 transition-all"
                                    >
                                        Contact Us
                                    </Link>

                                </div>

                                <div className="bg-white rounded-[24px] p-8 mt-8">

                                    <h3 className="text-2xl font-semibold">
                                        Event Transportation Benefits
                                    </h3>

                                    <div className="mt-6 space-y-4 text-[#666666]">
                                        <p>✓ Professional Image</p>
                                        <p>✓ On-Time Arrivals</p>
                                        <p>✓ Better Guest Experience</p>
                                        <p>✓ Simplified Logistics</p>
                                        <p>✓ Improved Productivity</p>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </section>

        </section>
    );
};

export default ReliableTransportationForBusinessEvents;